import { useMemo } from "react"
import type {
  DiscountTargetEnum,
  DiscountType,
  ItemTypeEnum,
  Maybe,
} from "types"
import { checkValueOrArray } from "../utils/checkValueOrArray"

export const useDiscountSpinner = (
  discounts: DiscountType[],
  targetType?: Maybe<ItemTypeEnum | ItemTypeEnum[]>,
  target?: Maybe<DiscountTargetEnum | DiscountTargetEnum[]>
): boolean => {
  return useMemo(() => {
    if (!targetType && !target) {
      return discounts.some((d) => d.state === "indeterminate")
    }

    if (!targetType) {
      return discounts.some(
        (d) =>
          d.state === "indeterminate" &&
          d.effects.some((effect) =>
            checkValueOrArray(
              effect?.target as string,
              target as DiscountTargetEnum | DiscountTargetEnum[]
            )
          )
      )
    }

    if (!target) {
      return discounts.some(
        (d) =>
          d.state === "indeterminate" &&
          d.effects.some((effect) =>
            checkValueOrArray(
              effect?.targetType as string,
              targetType as ItemTypeEnum | ItemTypeEnum[]
            )
          )
      )
    }

    return discounts.some(
      (d) =>
        d.state === "indeterminate" &&
        d.effects.some(
          (effect) =>
            checkValueOrArray(
              effect?.targetType as string,
              targetType as ItemTypeEnum | ItemTypeEnum[]
            ) &&
            checkValueOrArray(
              effect?.target as string,
              target as DiscountTargetEnum | DiscountTargetEnum[]
            )
        )
    )
  }, [discounts, targetType, target])
}
